import axios, { AxiosInstance } from 'axios';
import Cookies from 'js-cookie';

function getCookieToken(): string | null {
  try {
    const raw = Cookies.get('token');
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    // cookie structure is { data: { accessToken, refreshToken, ... } }
    return parsed?.data?.accessToken ?? null;
  } catch {
    return null;
  }
}

function getLocalStorageToken(): string | null {
  try {
    const raw = localStorage.getItem('tokenLogin');
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.data?.accessToken ?? null;
  } catch {
    return null;
  }
}

function getAccessToken(): string | null {
  return getCookieToken() || getLocalStorageToken();
}

function attachAuth(instance: AxiosInstance) {
  instance.interceptors.request.use((config) => {
    const token = getAccessToken();
    if (token) {
      config.headers = {
        ...(config.headers || {}),
        Authorization: `Bearer ${token}`,
      };
    }
    return config;
  });

  instance.interceptors.response.use(
    (resp) => resp,
    (error) => {
      // Handle 401 consistently
      if (error?.response?.status === 401) {
        // Optional: clear local storage
        try {
          localStorage.removeItem('tokenLogin');
        } catch {}
        const isDev = typeof window !== 'undefined' && window.location.hostname === 'localhost';
        const redirectUrl = isDev ? 'http://localhost:3000/login' : 'https://ilaws.net/login';
        if (typeof window !== 'undefined') {
          window.location.href = redirectUrl;
        }
      }
      return Promise.reject(error);
    },
  );
}

export const profileClient: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_Profile,
});
attachAuth(profileClient);

export const mainClient: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});
attachAuth(mainClient);